/** Formatação de datas/textos para a UI, sempre em PT-BR e sentence case. */

export function diasAtras(dias: number | null): string {
  if (dias === null) return "ainda não oferecido";
  if (dias === 0) return "hoje";
  if (dias === 1) return "ontem";
  return `há ${dias} dias`;
}

export function dataCurta(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
}

export function dataHora(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Parse seguro de "YYYY-MM-DD" como data local (evita shift de fuso). */
function dataLocal(iso: string | null): Date | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

/** Idade em anos a partir da data de nascimento (YYYY-MM-DD). */
export function idade(dataNascimento: string | null): number | null {
  const n = dataLocal(dataNascimento);
  if (!n) return null;
  const h = new Date();
  let a = h.getFullYear() - n.getFullYear();
  const m = h.getMonth() - n.getMonth();
  if (m < 0 || (m === 0 && h.getDate() < n.getDate())) a--;
  return a >= 0 ? a : null;
}

/** Data de nascimento formatada em PT-BR, ou null. */
export function dataNascimentoFmt(dataNascimento: string | null): string | null {
  const d = dataLocal(dataNascimento);
  return d ? d.toLocaleDateString("pt-BR") : null;
}

export function ehHoje(iso: string): boolean {
  const d = new Date(iso);
  const h = new Date();
  return (
    d.getFullYear() === h.getFullYear() &&
    d.getMonth() === h.getMonth() &&
    d.getDate() === h.getDate()
  );
}
